import AlternatePickup from 'components/Checkout/Sections/AlternatePickup/AlternatePickup';

export default AlternatePickup;
